export const getTypeTitleByValue = (value, array) => {
    const type = array.find(
        element => element.value === value
    );
    if (type !== undefined) {
        return type.title;
    } else {
        return '';
    }
};



// WEBPACK FOOTER //
// ./src/utils/Configuration.js